var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 17,
    viewBox: "0 0 74 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.134 3.39883C75.0007 8.1655 71.0673 13.8488 64.3507 16.0822C57.634 18.3322 50.6673 16.2822 48.784 11.5155C46.9173 6.74883 50.684 4.78216 57.4007 2.53216C64.1173 0.282164 71.2507 -1.36783 73.134 3.39883ZM0.867328 3.39883C-0.999339 8.1655 2.93399 13.8488 9.65066 16.0822C16.3673 18.3322 23.334 16.2822 25.2173 11.5155C27.084 6.74883 23.3173 4.78216 16.6007 2.53216C9.88399 0.282164 2.75066 -1.36783 0.867328 3.39883Z",
    fill: "#0CC5FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyes);
export default __webpack_public_path__ + "static/media/eyes.7717467b6ce997af8f0d668580cdbaba.svg";
export { ForwardRef as ReactComponent };